import { TreeNode } from 'primeng/api';

export interface SharedSelectTreeChangeEventOutput {
  filter: number[];
  prefill: TreeNode[];
}
